// src/Components/PreOrderModal/PreOrderModal.js
import React, { useState } from "react";
import "./PreOrderModal.css";
import { toast } from "react-toastify";
import { useSelector } from 'react-redux';
import { BACKEND_URL } from "../../services/Helper";
import { useNavigate } from "react-router-dom";

const notifySuccess = (msg) => toast.success(msg);
const notifyError = (msg) => toast.error(msg);

export default function PreOrderModal({ open, onClose, offer }) {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [quantity, setQuantity] = useState(1);
    const [arrival, setArrival] = useState("15"); // default 15 minutes
    const [sending, setSending] = useState(false);
    const user = useSelector((state) => state.nearbeUser.user);
    if (!open) return null;

    const handleNext = () => {
        if (!quantity || quantity <= 0) return notifyError("Please enter valid quantity.");
        if (!arrival || arrival <= 0) return notifyError("Please enter valid arrival time in minutes.");
        setStep(2);
    };

    const handleSend = async () => {
        if (!offer) return notifyError("Offer missing.");
        setSending(true);

        try {
            const body = {
                offerTitle: offer.title,
                offerDescription: offer.description,
                quantity,
                arrivalMinutes: arrival,
                userPhone: user?.phoneNumber,
                shopOwnerEmail: offer?.postedBy?.email
            };
            const token = localStorage.getItem("nearbeusertoken");
            if (!token) {
                navigate("/userlogin");
                return;
            }
            const res = await fetch(`${BACKEND_URL}/nearbe/preorderrequest`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body),
            });

            if (!res.ok) {
                const err = await res.json().catch(() => ({ message: 'Failed' }));
                throw new Error(err.message || "Failed to send pre-order");
            }

            notifySuccess("Pre-order request sent to the shop owner.");
            onClose();
        } catch (err) {
            console.error(err);
            notifyError(err.message || "Something went wrong");
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="preorder-modal-backdrop">
            <div className="preorder-modal">
                <button className="close-btn" onClick={() => { setStep(1); onClose(); }}>✕</button>

                <h2>Pre-order Request</h2>

                <div className="offer-summary">
                    <strong>{offer?.title || offer?.itemName}</strong>
                    <p className="desc">{offer?.description}</p>
                </div>

                {step === 1 && (
                    <>
                        <label>
                            Quantity
                            <input
                                type="number"
                                min="1"
                                value={quantity}
                                onChange={(e) => setQuantity(parseInt(e.target.value || "0", 10))}
                            />
                        </label>

                        <label>
                            Arrival time (min)
                            <input
                                type="number"
                                min="1"
                                value={arrival}
                                onChange={(e) => setArrival(e.target.value)}
                            />
                        </label>

                        <div className="modal-actions">
                            <button className="btn" onClick={handleNext}>Next</button>
                            <button className="btn secondary" onClick={() => { setStep(1); onClose(); }}>Cancel</button>
                        </div>
                    </>
                )}

                {step === 2 && (
                    <>
                        <div className="note">
                            <p><strong>Note:</strong> If you don't visit the shop within the given arrival time, the owner will wait for an extra 10 minutes and then may cancel your request.</p>
                        </div>

                        <div className="summary">
                            <p><strong>Qty:</strong> {quantity}</p>
                            <p><strong>Arrival:</strong> In {arrival} minutes</p>
                            <p><strong>Contact:</strong> {user?.phoneNumber || "Not provided"}</p>
                        </div>

                        <div className="modal-actions">
                            <button className="btn" onClick={handleSend} disabled={sending}>
                                {sending ? "Sending..." : "Send"}
                            </button>
                            <button className="btn secondary" onClick={() => setStep(1)}>Back</button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
